/*
 * Onboarding resume persistence (localStorage-backed).
 *
 * The onboarding form state lives in `secureStorage`, which is
 * sessionStorage-backed — so it is wiped when the user closes the app /
 * browser. That breaks "Continue Setup" after a full reopen: the user
 * loses both WHICH screen they were on and WHAT they had entered.
 *
 * This module mirrors two things to localStorage (which survives reopen):
 *   1. The last onboarding ROUTE the user was on (e.g. "/business-step")
 *      so Continue Setup can reopen the exact screen they left from.
 *   2. A SNAPSHOT of the onboarding secureStorage keys so the resumed
 *      screen can restore the user's selections (business category,
 *      place details, language, etc.).
 *
 * The legacy guided flow ("/steps") is intentionally never persisted or
 * resumed — Continue Setup must never land there.
 */

const ROUTE_KEY = "rexpt_onboarding_resume_route";
const SNAPSHOT_KEY = "rexpt_onboarding_resume_snapshot";

// secureStorage keys that make up the resumable onboarding state. Kept in
// sync with BusinessStep's hydrate reads + its "new agent" clear list.
export const ONBOARDING_RESUME_KEYS = [
  "currentStep",
  "businessType",
  "businessSubtype",
  "customBusiness",
  "subType",
  "displayBusinessName",
  "googleListing",
  "businessUrl",
  "websiteValidatedUrl",
  "placeDetailsExtract",
  "selectedSiteMapUrls",
  "selectedSiteMapUrls_backup",
  "urls",
  "viewSiteMap",
  "aboutBusinessForm",
  "showNoGMBCheckbox",
  "agentLanguage",
  "agentLanguageCode",
  "agentRole",
  "agentName",
  "timezone",
  "currentAgentSessionId",
  "categoryAutoPicked",
  // "category screen is journey me dikhi thi" — progress dots 2 vs 3 isi se
  // decide hote hain, isliye resume/reload par bhi bachna chahiye.
  "categoryScreenShown",
];

export const saveResumeRoute = (route) => {
  try {
    if (!route || route === "/steps" || route === "/details") return;
    localStorage.setItem(ROUTE_KEY, route);
  } catch (_e) {
    /* localStorage unavailable — best effort */
  }
};

export const getResumeRoute = () => {
  try {
    const r = localStorage.getItem(ROUTE_KEY);
    // Never resume into the legacy guided flow or details screen.
    return r && r !== "/steps" && r !== "/details" ? r : null;
  } catch (_e) {
    return null;
  }
};

export const saveResumeSnapshot = (snapshot) => {
  try {
    localStorage.setItem(SNAPSHOT_KEY, JSON.stringify(snapshot));
  } catch (_e) {
    /* quota / serialization issues — best effort */
  }
};

export const getResumeSnapshot = () => {
  try {
    const s = localStorage.getItem(SNAPSHOT_KEY);
    return s ? JSON.parse(s) : null;
  } catch (_e) {
    return null;
  }
};

export const clearOnboardingResume = () => {
  try {
    localStorage.removeItem(ROUTE_KEY);
    localStorage.removeItem(SNAPSHOT_KEY);
  } catch (_e) {
    /* best effort */
  }
};
